import React from 'react'

import Header from '../../templates/Header';
import Footer from '../../templates/Footer';
import SEO from '../../templates/SEO';

import Testimonials from '../../templates/Testimonials';

import course_1 from '../../../assets/images/course-1.jpg';

function Adv_Options_Strategies() {
  return (
    <div>
          
<SEO title="Advanced Options Strategies Page"/>

<Header/>


<div class=" aboutarea__5">
    <div class="container">
        <div class="row">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                <div class="herobannerarea__content__wraper">


                    <div class="herobannerarea__title">
                        <div class="herobannerarea__small__title">
                            <span>ADVANCE PROGRAMS</span>
                        </div>
                        <div class="herobannerarea__title__heading__2 herobannerarea__title__heading__3">
                            <h2>Advanced Options Strategies</h2>
                        </div>
                    </div>


                    <div class="herobannerarea__text herobannerarea__text__2">
                        <p>Unlock the power of professional options trading with our comprehensive program. Learn to leverage market movements using sophisticated strategies that balance risk and reward. Whether you're looking to capitalize on volatility, hedge positions, or generate consistent income, this course equips you with the institutional-grade techniques used by seasoned traders.</p>
                    </div>
                    {/* <div class="hreobannerarea__button__2">
                        <a class="default__button" href="#">View Courses</a>
                        <a class="default__button hreobannerarea__button__3" href="#">Explore More</a>
                    </div> */}
                </div>


                <div class="aboutarea__list__2">
                    <p>What you'll learn: </p>
                        <ul>
                            <li>
                               ✅ &nbsp; Long Call/Put
                            </li>

                            <li>
                            ✅ &nbsp; Straddle/Strangle
                            </li>

                            <li>
                            ✅ &nbsp; Credit/Debit Spreads
                            </li>
                            <li>
                            ✅ &nbsp; Iron Condor/Fly
                            </li>
                            <li>
                            ✅ &nbsp; Options Hedging
                            </li>
                            <li>
                            ✅ &nbsp; Futures + Options
                            </li>
                            <li>
                            ✅ &nbsp; Volatility Trading
                            </li>
                           
                           

                        </ul>
                    </div>
{/* <div class="hreobannerarea__button__2">
                        <a class="default__button" href="#">Buy Now</a>
                        <a class="default__button hreobannerarea__button__3" href="/contact">Contact Us</a>
                    </div> */}




            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">

                {/* <div class="herobanner__video registerarea__video">
                    <img loading="lazy" src="img/herobanner/herobanner__video.jpg" alt="Video Banner" />

                    <div class="video__pop__btn">
                        <a class="video-btn" href="https://www.youtube.com/watch?v=vHdclsdkp28"> <img loading="lazy" src="img/icon/video.png" alt=""/></a>
                    </div>
                </div> */}



<div class="gridarea__wraper">
                            <div class="gridarea__img">
                                <a href="course-details.html"><img loading="lazy"  src={course_1} alt="grid"/></a>
                                <div class="gridarea__small__button gridarea__small__button__1">
                                    <div class="grid__badge">Advance Programs</div>
                                </div>
                                <div class="gridarea__small__icon">
                                    <a href="#"><i class="icofont-heart-alt"></i></a>
                                </div>

                            </div>
                            <div class="gridarea__content">
                              
                                <div class="gridarea__heading">
                                    <h3><a href="">Advanced Options Strategies</a></h3>
                                    <p>Pro-level options trading</p>
                                </div>
                               
                                <div class="gridarea__price">
                                ₹19,999 + GST 
                                </div>
                                <div class="hreobannerarea__button__2">
                        <a class="default__button d-block text-center"  href="#">Buy Now</a>
                        
                    </div>
                 
                            </div>
                        </div>





                

            </div>

         
        </div>
    </div>
</div>


<Testimonials/>





<Footer/>

    </div>
  )
}

export default Adv_Options_Strategies
